module.exports = __webpack_public_path__ + "static/media/Proposal_Writing_Notification.1fd1b1d7.png";